import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  note: {
    required,
  },
  userId: {
    required,
  },
  categoryIds: {
    required,
  },
};

export default validations;